import axios from 'axios';

export const HouseApi = {
    createHouse(projectId, referenceHouseId) {
        return new Promise((resolve, reject) => {
            axios.post(`/projects/${projectId}/housemodel/api/houses`, { referenceHouseId: referenceHouseId })
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        });
    },
    createHouseWithCustomRefHouse(projectId, customReferenceHouse) {
        return new Promise((resolve, reject) => {
            axios.post(`/projects/${projectId}/housemodel/api/houses`, {
                    referenceHouseId: -1,
                    customReferenceHouse: customReferenceHouse
                })
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        });
    },
    getHouses(projectId) {
        return new Promise((resolve, reject) => {
            axios.get(`/projects/${projectId}/housemodel/api/houses`)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        });
    },
    removeHouse(projectId, houseId) {
        return new Promise((resolve, reject) => {
            axios.delete(`/projects/${projectId}/housemodel/api/houses/${houseId}`)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        });
    },
    updateHouses(projectId, houses) {
        return new Promise((resolve, reject) => {
            axios.put(`/projects/${projectId}/housemodel/api/houses`, { houses: houses })
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        });
    },
}



// WEBPACK FOOTER //
// ./assets/vue/houseModel/api/houseApi.js